import React from 'react';
import moment from 'moment';
import DateFormat from 'constants/date_format';
import { localTime } from './LocalTimeAndTimeZone';

const CalendarGraphic = ({ convertToLocalTime, isRsvpPage, session }) => {
  if (!session) {
    return <div style={{ display: 'none' }}>Session not found.</div>;
  }

  const startTime = convertToLocalTime
    ? localTime(session.startTime || session.start_time)
    : session.startTime || session.start_time;

  const baseClass = isRsvpPage ? 'MySessionListCard' : 'MyTrainingEventsCard';

  return (
    <div className={`${baseClass}-calendarGraphic d-f ai-c`}>
      <div
        className={`${baseClass}-calendarGraphic--month llui-text-instrux-semibold`}
      >
        {moment(startTime, DateFormat.fixed.ISO8601_LOCAL).format(
          DateFormat.fixed.LONG_MONTH,
        )}
      </div>
      <div className={`${baseClass}-calendarGraphic--day`}>
        {moment(startTime, DateFormat.fixed.ISO8601_LOCAL).format(
          DateFormat.fixed.NUMBER_DAY,
        )}
      </div>
    </div>
  );
};

export default CalendarGraphic;
